module.exports = global["Tether"] = require("-!./tether.js");


//////////////////
// WEBPACK FOOTER
// ./~/tether/dist/js/tether.js-exposed
// module id = 40
// module chunks = 0